! function (e) {
    "use strict";

    function stickyHeader() {
        if (window.pageYOffset > sticky) {
            header.addClass("sticky");
        } else {
            header.removeClass("sticky");
        }
    }

    window.onscroll = function() {stickyHeader();}
    var header = $('.nav-bar');
    var sticky = 25;
    stickyHeader();

}(jQuery);
